import { Dialog } from "@rio-cloud/rio-uikit";
import { useIntl } from "react-intl";
import { reasonsRefusalOptions } from "../../../../../../../hooks/useDispatch";

interface RefusalReasonDialogProps {
  show: boolean;
  onClose: () => void;
  newRefusal: { reason: string; description: string };
  cancelledBy?: string;
}

const RefusalReasonDialog = (props: RefusalReasonDialogProps) => {
  const intl = useIntl();

  return (
    <Dialog
      show={props.show}
      onClose={props.onClose}
      showCloseButton
      bsSize={Dialog.SIZE_SM}
    >
      <Dialog.Title title="Indisponibilidade" />
      <Dialog.Body>
        <div className="flex flex-col">
          <div className="font-semibold mt-4">Motivo de indisponibilidade</div>
          <div>{reasonsRefusalOptions.find(option => option.id === props.newRefusal?.reason)?.label ?? 'Outro'}</div>
          <div className="font-semibold mt-4">Descrição</div>
          <div>{props.newRefusal?.description}</div>
          {props.cancelledBy ? (
            <>
              <div className="font-semibold mt-4">
                {intl.formatMessage({ id: "intl-msg:dispatch.cancelledBy" })}
              </div>
              <div>{props.cancelledBy}</div>
            </>
          ) : null}
        </div>
      </Dialog.Body>
      <Dialog.Footer>
        <div className="flex items-center justify-center my-4">
          <button className="btn btn-primary btn-link" onClick={props.onClose}>Voltar</button>
        </div>
      </Dialog.Footer>
    </Dialog>
  );
};

export default RefusalReasonDialog;
